if (!window.Maximize.loadedScript.includes("locales-form.js")) {
  window.Maximize.loadedScript.push("locales-form.js");

  requestAnimationFrame(() => {
    document.addEventListener("alpine:init", () => {
      Alpine.data("xLocalizationForm", (language) => ({
        localizationForm: "",
        openForm: false,
        openCountry: false,
        openLanguage: false,
        loading: false,
        cachedResults: false,
        currentCountrySelector: '',
        languageSelector: language,
        init() {
          // Quicktrolly (22 Oct 2026): on phones, focusing or leaving the country search box
          // makes the browser scroll the page (keyboard / zoom). Both this component and
          // <select-element> close on window scroll, so mark a short grace period around
          // focus/blur during which such scrolls are ignored.
          const search = this.$el.querySelector(".qt-country-search");
          if (!search) return;
          const mark = () => {
            const until = Date.now() + 1000;
            this._qtIgnoreScrollUntil = until;
            const selectEl = search.closest("select-element");
            if (selectEl) selectEl._ignoreScrollUntil = until;
          };
          search.addEventListener("focus", mark);
          search.addEventListener("blur", mark);
        },
        toggleOpenForm() {
          this.openForm = !this.openForm;
        },
        submit() {
          this.$el.closest("#localization_form").submit();
        },
        loadCountry(el) {
          if (this.cachedResults) {
            this.openCountry = true;
            return true;
          }
          let countrySelectorElement = el.closest(".country-selector");
          let optionEL = countrySelectorElement.querySelector(".country-options");
          this.loading = true;
          this.currentCountrySelector = this.$refs.currentCountry.innerText.toLowerCase();
          const _this = this;
          fetch(window.Shopify.routes.root + "?section_id=country-selector")
            .then((reponse) => {
              return reponse.text();
            })
            .then((response) => {
              const parser = new DOMParser();
              const content = parser
                .parseFromString(response, "text/html")
                .getElementById("list-country");
              
              optionEL.innerHTML = content.innerHTML;
              requestAnimationFrame(() => {
                const countryLists = optionEL.querySelectorAll('li[role="button"]');

                countryLists.forEach(country => {
                  country.addEventListener('click', () => {
                    _this.setSelectCountry(el, country);
                    if (!countrySelectorElement.dataset.showPopup) el.closest("#localization_form").submit();
                  });

                  country.addEventListener('keydown', (event) => {
                    if (event.key === 'Enter' || event.key === ' ') {
                      _this.setSelectCountry(el, country);
                      if (!countrySelectorElement.dataset.showPopup) el.closest("#localization_form").submit();
                    }
                  });
                });
              })
              this.cachedResults = true;
              this.openCountry = true;
            })
            .finally(() => {
              setTimeout(() => {
                this.loading = false;
                countrySelectorElement.handleOpen();
                countrySelectorElement.optionsList.classList.remove("p-0");
              }, 300)
            });
        },
        handleOptionEvent(currency_selector, rowItem, language, selector) {
          const _this = this;
          this.$el.addEventListener('click', () => {
            _this.setSelectLanguage(rowItem, language, selector);
            if (currency_selector === 'false') _this.submit();
          })
          this.$el.addEventListener('keydown', (event) => {
            if (event.key === 'Enter' || event.key === ' ') {
              _this.setSelectLanguage(rowItem, language, selector);
              if (currency_selector === 'false') _this.submit();
            }
          });
        },
        setSelectLanguage(rowItem, language, selector) {
          this.$el.closest("#localization_form").querySelector("#" + selector).value = language;
          this.languageSelector = rowItem;
          this.openLanguage = false;
        },
        setSelectCountry(el, country) {
          el.closest("#localization_form").querySelector("#currency_selector").value = country.dataset.country;
          this.currentCountrySelector = country.dataset.countryTitle.toLowerCase();
          this.openCountry = false;
          this.syncLanguages(el, country);
        },
        // Quicktrolly (23 Oct 2026): the Language list is rendered for the country the page was
        // loaded with, so after picking Spain it still showed Germany's languages until Save
        // reloaded the page. Languages per country come from the <script class="qt-country-languages">
        // JSON in localization-form.liquid (fallback: data-languages on the country <li>).
        // Rebuild the Language list from them right away. If no language data is available,
        // reload the page in the new country so the correct languages appear (never stuck).
        syncLanguages(el, country) {
          const form = el.closest("#localization_form");
          if (!form) return;
          const code = country.dataset.country;
          let raw = "";
          const mapEl = form.querySelector(".qt-country-languages");
          if (mapEl) {
            try { raw = (JSON.parse(mapEl.textContent) || {})[code] || ""; } catch (e) { raw = ""; }
          }
          if (!raw) raw = country.dataset.languages || "";
          const langSelect = form.querySelector(".language-selector");
          if (!langSelect) return;
          const langs = raw.split(";;").map((p) => p.split("|")).filter((p) => p.length === 2 && p[0]);
          const ul = langSelect.querySelector(".select-options");
          const hidden = langSelect.querySelector("#locale_selector");
          const label = langSelect.querySelector(".select-button__label");
          if (!langs.length || !ul || !hidden) {
            form.submit();
            return;
          }
          const current = hidden.value;
          const chosen = langs.find((l) => l[0] === current) || langs[0];
          const _this = this;
          ul.innerHTML = "";
          langs.forEach(([iso, name]) => {
            const li = document.createElement("li");
            const selected = iso === chosen[0];
            li.className = "select-option rounded-corners font-normal" + (selected ? " selected" : "");
            li.dataset.optionName = name;
            li.dataset.value = iso;
            li.dataset.selectValue = name;
            li.dataset.type = "dropdown";
            li.setAttribute("data-no-instant", "");
            li.setAttribute("role", "option");
            li.setAttribute("aria-selected", selected ? "true" : "false");
            li.tabIndex = -1;
            li.textContent = name;
            li.addEventListener("click", () => _this.setSelectLanguage(name, iso, "locale_selector"));
            li.addEventListener("keydown", (event) => {
              if (event.key === "Enter" || event.key === " ") _this.setSelectLanguage(name, iso, "locale_selector");
            });
            ul.appendChild(li);
          });
          hidden.value = chosen[0];
          this.languageSelector = chosen[1];
          if (label) label.textContent = chosen[1];
        },
        initPosition(position) {
          if (this.$el.closest("#x-utility") && position) {
            this.getScrollPosition(position, true)

            window.addEventListener('resize', () => {
              this.getScrollPosition(position, false)
            });
          }
        },
        initEventScroll() {
          const mobile_menu_scroll_ele = document.querySelector('#menu-navigation .scrollbar-visible.overflow-y-auto');
          if (mobile_menu_scroll_ele && this.$el.closest("#utility-bar-mobile")) {
            mobile_menu_scroll_ele.addEventListener("scroll", () => {
              this.openForm = false;
            });
          }

          window.addEventListener("scroll", () => {
            // Quicktrolly (22 Oct 2026): keep the panel open while the country search box
            // has focus, and for the grace period set in init() around focus/blur.
            const active = document.activeElement;
            if (active && active.classList && active.classList.contains("qt-country-search") && this.$el.contains(active)) return;
            if (this._qtIgnoreScrollUntil && Date.now() < this._qtIgnoreScrollUntil) return;
            this.openForm = false;
          });
        },
        getScrollPosition(position, loadPage) {
          var container = this.$el.closest(".link-list");
          // Gets the element's position relative to the container
          var itemRect = this.$el.getBoundingClientRect();
          var containerRect = container.getBoundingClientRect();
          var xUtility = document.getElementById("x-utility")
          if (position == 'right') {
            var elementComputedStyle = getComputedStyle(xUtility);
            var padding = loadPage ? parseFloat(elementComputedStyle.paddingRight) : parseFloat(elementComputedStyle.paddingRight);
            let distance = (containerRect.right - itemRect.right) > 0 ? (containerRect.right - itemRect.right) : (itemRect.right - containerRect.right)
            this.$el.nextElementSibling.style.right = distance + padding + "px"
          } else {
            var elementComputedStyle = getComputedStyle(xUtility)
            var padding = loadPage ? 0 : parseFloat(elementComputedStyle.paddingLeft);
            
            this.$el.nextElementSibling.style.left = itemRect.left - padding +  "px"
          }
        }
      }));
    });
  });
}
